import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { GenericImportPage } from '@driftt/crm-components'
import {
  A,
  Div,
  H3,
  Li,
  Ul
} from '@driftt/tide-core'
import {
  fetchFromPardot as fetchFromPardotEndpoint,
  getPardotLists,
  pausePardotLists,
  syncPardotLists
} from 'api/imports'
import {
  getOrgPardotAccessType,
  PardotAccessTypes,
  shouldShowPardotImports
} from 'utils/pardotAccess'

import PardotImportTableConfig from './PardotImportTableConfig'

import './style.css'

const hasAccessToPardotImport = () => {
  const hasAccess = getOrgPardotAccessType() === PardotAccessTypes.HAS_ACCESS_CONNECTED

  return shouldShowPardotImports() && hasAccess
}

const ListTypes = [
  {
    key: 'DYNAMIC',
    displayName: 'Dynamic List',
    displayNamePlural: 'Dynamic Lists',
    iconKey: 'lightning-bolt'
  },
  {
    key: 'STATIC',
    displayName: 'Static List',
    displayNamePlural: 'Static Lists',
    iconKey: 'list-bullets'
  }
]

const ModalBody = () => (
  <Div className="pardot-import--modal-body">
    <H3>Pardot sync information</H3>
    <Ul>
      <Li>Only contacts with a <span class="pardot-import-modal-text-semi-bold">visitor_id</span> in their <span class="pardot-import-modal-text-semi-bold">last_activity</span> will be synced from Pardot. Contacts without this value will not be synced to Drift. <A href="https://gethelp.drift.com/hc/en-us/articles/360023059673-How-to-Set-Up-Pardot-Targeting" rel="noopener noreferrer"
        target="_blank">Learn more
      </A>
      </Li>
      <br/>
      <Li>Imported lists will be saved as Drift segments.</Li>
    </Ul>
  </Div>
)

const fetchPardotLists = async ({
  query,
  type
}) => {
  const data = await getPardotLists({
    query,
    type
  })

  return data.data
}

const LAST_FETCH_TIME_KEY = 'pardot-imports--last-fetch-time'

const fetchFromPardotOnPageLoad = async () => {
  const now = moment()

  const lastFetchTime = window.localStorage.getItem(LAST_FETCH_TIME_KEY)
  const hasNotFetchedYet = !lastFetchTime

  if (hasNotFetchedYet) {
    return await fetchFromPardot()
  }

  const lastFetchMoment = moment(Number(lastFetchTime))
  const hasFetchedMoreThanOneDayAgo = now.diff(lastFetchMoment, 'days') > 0

  if (hasFetchedMoreThanOneDayAgo) {
    return await fetchFromPardot()
  }
}

const fetchFromPardot = async () => {
  const now = moment()

  window.localStorage.setItem(LAST_FETCH_TIME_KEY, now.valueOf())
  return await fetchFromPardotEndpoint()
}

const mapStateToProps = state => ({ bootstrapComplete: state.config.bootstrapComplete })

const PardotImport = ({ bootstrapComplete }) => {
  if(!bootstrapComplete) {return null}

  if (!hasAccessToPardotImport()) {
    return (
      <Redirect to="/imports" />
    )
  }

  return (
    <GenericImportPage
      title="Import Pardot Lists"
      integrationId="PARDOT"
      integrationDisplayName="Pardot"
      fetchLists={fetchPardotLists}
      fetchInitialData={fetchFromPardotOnPageLoad}
      refreshLists={fetchFromPardot}
      syncLists={syncPardotLists}
      pauseLists={pausePardotLists}
      listTypes={ListTypes}
      tableConfig={PardotImportTableConfig}
      modalBody={ModalBody}
    />
  )
}

export default connect(mapStateToProps)(PardotImport)

